(() => {
  const ANCHOR_SELECTOR = ".rbrVolumeContainer";
  const WIDGET_SELECTOR = '#rbr-container-element-volume, [id^="rbr-container-element-volume"], [data-rbrselector="volumeDiscount"]';
  const DISABLED_CLASS = "volume-discount--size-locked";
  const OPTION_SELECTOR = '[data-rbrselector="discountInfoV1"]';

  let lastEligible = null;
  let syncScheduled = false;
  let observed = false;

  function getOffers() {
    return Array.isArray(window.FastBundleVolumeOffers) ? window.FastBundleVolumeOffers : [];
  }

  function getWidgetRoots() {
    const roots = new Set();

    for (const node of document.querySelectorAll(WIDGET_SELECTOR)) {
      roots.add(node);
    }

    for (const anchor of document.querySelectorAll(ANCHOR_SELECTOR)) {
      const sibling = anchor.nextElementSibling;
      if (sibling && (sibling.id?.includes("rbr-container-element") || sibling.querySelector?.(OPTION_SELECTOR))) {
        roots.add(sibling);
      }

      const parent = anchor.closest(".shopify-block, .shopify-app-block") || anchor.parentElement;
      if (parent) {
        for (const option of parent.querySelectorAll(OPTION_SELECTOR)) {
          const root =
            option.closest('[data-rbrselector="volumeDiscount"]') ||
            option.closest('[id^="rbr-container-element"]') ||
            parent;
          roots.add(root);
        }
      }
    }

    return Array.from(roots);
  }

  function getCurrentVariantId() {
    const form =
      document.querySelector('product-form-component form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    const input = (form || document).querySelector('input[name="id"]');
    return input?.value ? String(input.value) : null;
  }

  function normalizeSize(value) {
    return String(value || "")
      .replace(/\s+/g, "")
      .replace(",", ".")
      .toLowerCase();
  }

  function isTenLSelected() {
    const fieldsets = document.querySelectorAll("variant-picker fieldset.variant-option");

    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector("legend")?.textContent || "";
      if (!/størrelse|storrelse|size/i.test(legend)) continue;

      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return false;

      return normalizeSize(checked.value || checked.getAttribute("aria-label")) === "10l";
    }

    return false;
  }

  function collectExcludedVariantIds(offers) {
    const ids = new Set();

    for (const offer of offers) {
      const excluded = offer?.item?.excluded_variants || offer?.excluded_variants || [];
      for (const id of excluded) {
        ids.add(String(id));
      }
    }

    return ids;
  }

  function offerTargetsTenL(offers) {
    return offers.some((offer) => /10\s*l/i.test(String(offer?.title || "")));
  }

  function widgetTargetsTenL(roots) {
    return roots.some((root) => /10\s*l/i.test(root.textContent || ""));
  }

  function isEligible(variantId, offers, roots) {
    if (!offers.length) {
      if (widgetTargetsTenL(roots)) return isTenLSelected();
      return true;
    }

    const excluded = collectExcludedVariantIds(offers);
    if (excluded.size > 0) {
      if (variantId) return !excluded.has(String(variantId));
      if (offerTargetsTenL(offers) || widgetTargetsTenL(roots)) return isTenLSelected();
      return false;
    }

    if (offerTargetsTenL(offers) || widgetTargetsTenL(roots)) {
      return isTenLSelected();
    }

    return true;
  }

  function hasNonDefaultOptionSelected(root) {
    const options = Array.from(root.querySelectorAll(OPTION_SELECTOR));
    if (options.length < 2) return false;

    const selectedIndex = options.findIndex((option) => option.querySelector('input[type="radio"]')?.checked);
    return selectedIndex > 0;
  }

  function resetToDefaultOption(root) {
    const firstOption = root.querySelector(OPTION_SELECTOR);
    if (!firstOption) return;

    const input = firstOption.querySelector('input[type="radio"]');
    if (input?.checked) return;

    firstOption.click();
  }

  function setQuantityToOne() {
    const quantityInput =
      document.querySelector("quantity-selector-component input") ||
      document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');

    if (!quantityInput || Number(quantityInput.value) === 1) return;

    quantityInput.value = "1";
    quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
    quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function applyLockState(eligible, roots) {
    if (!roots.length) return;

    const becameLocked = lastEligible === true && !eligible;

    for (const root of roots) {
      const wasLocked = root.classList.contains(DISABLED_CLASS);
      root.classList.toggle(DISABLED_CLASS, !eligible);
      root.setAttribute("aria-disabled", eligible ? "false" : "true");

      if (!eligible && (becameLocked || !wasLocked || hasNonDefaultOptionSelected(root))) {
        resetToDefaultOption(root);
      }
    }

    if (!eligible && (becameLocked || lastEligible === null)) {
      setQuantityToOne();
    }
  }

  function ensureObserver() {
    if (observed) return;
    observed = true;

    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function sync() {
    syncScheduled = false;
    ensureObserver();

    const offers = getOffers();
    const roots = getWidgetRoots();
    if (!roots.length && !offers.length) return;

    const eligible = isEligible(getCurrentVariantId(), offers, roots);
    applyLockState(eligible, roots);
    lastEligible = eligible;
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(sync);
  }

  function isEventInsideLockedWidget(target) {
    if (!(target instanceof Element)) return false;
    return Boolean(target.closest(`.${DISABLED_CLASS}`));
  }

  function blockLockedInteraction(event) {
    if (!isEventInsideLockedWidget(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
  }

  function bindVariantListeners() {
    document.addEventListener("variant:update", scheduleSync);
    document.addEventListener("variant:selected", scheduleSync);
    document.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.matches('input[name="id"], variant-picker input[type="radio"], variant-picker select')) {
        scheduleSync();
      }
    });

    document.addEventListener("click", blockLockedInteraction, true);
    document.addEventListener("pointerdown", blockLockedInteraction, true);
    document.addEventListener("keydown", blockLockedInteraction, true);

    const idInput = document.querySelector('input[name="id"]');
    if (idInput) {
      new MutationObserver(scheduleSync).observe(idInput, {
        attributes: true,
        attributeFilter: ["value"],
      });
    }
  }

  function bindFastBundleReady() {
    document.addEventListener("FastBundleVolumeOffersReady", scheduleSync);

    let attempts = 0;
    const poll = window.setInterval(() => {
      attempts += 1;
      const ready = getOffers().length > 0 || getWidgetRoots().length > 0;

      if (ready || attempts > 40) {
        window.clearInterval(poll);
        scheduleSync();
      }
    }, 250);
  }

  function init() {
    bindVariantListeners();
    bindFastBundleReady();
    scheduleSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
